module.exports = __webpack_public_path__ + "img/logo-grande-ac.ef3be55c.svg";